var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#3380FF","id":"a","cx":"25","cy":"25","r":"25","key":0}),React.createElement("path",{"d":"M21.434 50.125h8.196v-20.09h5.678l.606-6.73H29.63v-3.857c0-1.59.32-2.215 1.882-2.215h4.425V10.28h-5.684c-6.066 0-8.82 2.628-8.82 7.639v5.347h-4.245v6.875h4.246v19.983z","fill":"#FFF","fillRule":"nonzero","key":1})]));
}

Facebook.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Facebook;

Facebook.default = Facebook;
